import { ShipmentDeviationType, ShipmentTransitTime } from '../../../models';
import { DateWithTimezones, TransportMode } from '../../../../common';

export class ShipmentLoadOverview {
  reference: string;
  carrier: string;
  scacCode: string;

  shipmentCreated: DateWithTimezones;
  transitTime: ShipmentTransitTime;
  transportReceipt: DateWithTimezones;

  serviceRequirementCodes: string[];
  carriageConditionCodes: string[];
  transportServicePriorityCodes: string[];
  transportMode: TransportMode;

  houseAirWaybill: string | null = null;
  masterAirWaybill: string | null = null;
  houseBillOfLading: string;
  masterBillOfLading: string | null = null;
  vesselName: string;
  containerIds: string[];

  driverName: string;
  driverContact: string;
  truckPlate: string;
  trailerPlates: string[];
  cancelled: boolean;
  deviationStatus: ShipmentDeviationType;
}
